import { PageId } from 'constants/pages'

export const enum PageIdWoofzLove {
  DOG_SEX_LOVE = PageId.DOG_SEX_LOVE,
  DOG_AGE_LOVE = PageId.DOG_AGE_LOVE,
  URGE_LOVE = PageId.URGE_LOVE,
  FEELINGS_LOVE = PageId.FEELINGS_LOVE,
  URGE_1_LOVE = PageId.URGE_1_LOVE,
  TALKING_LOVE = PageId.TALKING_LOVE,
  DOG_FOLLOW_LOVE = PageId.DOG_FOLLOW_LOVE,
  LICKING_LOVE = PageId.LICKING_LOVE,
  URGE_2_LOVE = PageId.URGE_2_LOVE,
  BEHAVIOR_LOVE = PageId.BEHAVIOR_LOVE,
  FEEL_GUILTY_LOVE = PageId.FEEL_GUILTY_LOVE,
  URGE_3_LOVE = PageId.URGE_3_LOVE,
  DOG_REACT_LOVE = PageId.DOG_REACT_LOVE,
  SATISFIED_LOVE = PageId.SATISFIED_LOVE,
  BEHAVIOR_ISSUES_LOVE = PageId.BEHAVIOR_ISSUES_LOVE,
  YOUR_REACTION_LOVE = PageId.YOUR_REACTION_LOVE,
  URGE_4_LOVE = PageId.URGE_4_LOVE,
  COMMANDS_LOVE = PageId.COMMANDS_LOVE,
  DOG_BREED_LOVE = PageId.DOG_BREED_LOVE,
  DOG_NAME_LOVE = PageId.DOG_NAME_LOVE,
  LOVE_LOAD_SCREEN = PageId.LOVE_LOAD_SCREEN,
  DOG_PROFILE_LOVE = PageId.DOG_PROFILE_LOVE,
  MOTIVATION_LOVE = PageId.MOTIVATION_LOVE,
  FEEL_DOG_LOVE = PageId.FEEL_DOG_LOVE,
  FREQUENCY_LOVE = PageId.FREQUENCY_LOVE,
  PREPARE_FLOW_LOVE = PageId.PREPARE_FLOW_LOVE,
  EMAIL_LOVE = PageId.EMAIL_LOVE,
  NEWSLETTER_URGE_LOVE = PageId.NEWSLETTER_URGE_LOVE,
  PERSONALIZED_PLAN_LOVE = PageId.PERSONALIZED_PLAN_LOVE,
  LAST_CHANCE_OFFER_LOVE = PageId.LAST_CHANCE_OFFER_LOVE,
  SUBSCRIPTIONS_LOVE = PageId.SUBSCRIPTIONS_LOVE,
  LAST_CHANCE_OFFER_2_LOVE = PageId.LAST_CHANCE_OFFER_2_LOVE,
  CANCEL_OFFER_LOVE = PageId.CANCEL_OFFER_LOVE,
  CHAT_UPSELL_LOVE = PageId.CHAT_UPSELL_LOVE,
  UPSELL_LOVE = PageId.UPSELL_LOVE,
  UPSELL_FEEDING_GUIDE_LOVE = PageId.UPSELL_FEEDING_GUIDE_LOVE,
  UPSELL_EMOTIONAL_SUPPORT_LOVE = PageId.UPSELL_EMOTIONAL_SUPPORT_LOVE,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_LOVE = PageId.DOWNLOAD_LOVE,
}
